import { Box, Button, SvgIcon, Toolbar, Typography } from '@mui/material';
import FileDownload from 'mdi-react/FileDownloadIcon';
import RefreshIcon from 'mdi-react/RefreshIcon';
import { bool, func, object, string } from 'prop-types';
import React, { Component } from 'react';
import { I18n } from 'utils/i18n';
import Search from './Search';

const toolbarSx = {
  display: 'flex',
  justifyContent: 'space-between',
  paddingRight: 1,
  marginBottom: '16px',
};

const actionsSx = {
  display: 'flex',
  color: 'text.secondary',
  flex: '1 0 auto',
};

const titleSx = {
  fontWeight: 600,
};

const buttonSx = {
  minWidth: 36,
  margin: '0 10px',
  color: 'primary.ultraDark',
};

const plusSx = {
  fontSize: 18,
  marginRight: '5px',
  color: 'primary.main',
};

class EnhancedTableToolbar extends Component {
  state = {
    searchValue: '',
  };

  handleSearch = e => {
    const { onSearch } = this.props;
    this.setState({ searchValue: e.target.value });
    onSearch(e.target.value);
  };

  render() {
    const { tab, children, onExport, onGenerateReports, complianceEnabled, isGenerating } =
      this.props;
    const { searchValue } = this.state;
    return (
      <Toolbar sx={toolbarSx}>
        <Typography component="div" sx={titleSx} variant="h5">
          {I18n.t(`Header.tabs.${tab}`)}
        </Typography>
        <Box sx={actionsSx}>
          {children}
          <Search onChange={this.handleSearch} value={searchValue} />
          <Button variant="outlined" color="secondary" sx={buttonSx} onClick={onExport}>
            <SvgIcon sx={plusSx}>
              <FileDownload />
            </SvgIcon>
            {I18n.t('TimeTracking.Export report')}
          </Button>
          {complianceEnabled && (
            <Button
              variant="outlined"
              color="secondary"
              sx={buttonSx}
              onClick={onGenerateReports}
              disabled={isGenerating}
            >
              <SvgIcon sx={plusSx}>
                <RefreshIcon />
              </SvgIcon>
              {isGenerating
                ? I18n.t('TimeTracking.Generating')
                : I18n.t('TimeTracking.GenerateMonthlyReports')}
            </Button>
          )}
        </Box>
      </Toolbar>
    );
  }
}

EnhancedTableToolbar.propTypes = {
  onSearch: func.isRequired,
  tab: string.isRequired,
  children: object.isRequired,
  onExport: func.isRequired,
  onGenerateReports: func,
  complianceEnabled: bool,
  isGenerating: bool,
};

EnhancedTableToolbar.defaultProps = {
  onGenerateReports: null,
  complianceEnabled: false,
  isGenerating: false,
};

export default EnhancedTableToolbar;
